import { Action } from '../../shared/models/action.model';
import { updateAction } from '../../utils/utility';
import { REPORTING_AND_ANALYTICS } from '../types/reportingAndAnalyticsTypes';

export const fetchReportingTransactionMeta = (payload: any): Action<any> => {
  return updateAction(
    REPORTING_AND_ANALYTICS.FETCH_REPORTING_TRANSACTION_META,
    payload,
  );
};

export const fetchReportingTransactionData = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.FETCH_TRANSACTION_DATA, payload);
};

export const fetchTransactionData = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.FETCH_TRANSACTION_DATA, payload);
};

export const setReportingTransactionMeta = (payload: any): Action<any> => {
  return updateAction(
    REPORTING_AND_ANALYTICS.SET_REPORTING_TRANSACTION_META,
    payload,
  );
};

export const setTransactionReportFilters = (payload: any): Action<any> => {
  return updateAction(
    REPORTING_AND_ANALYTICS.SET_TRANSACTION_REPORT_FILTERS,
    payload,
  );
};

export const setClaimStatus = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.SET_CLAIM_STATUS, payload);
};

export const setConfigPayer = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.SET_CONFIG_PAYER, payload);
};

export const setDateRangeClicked = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.SET_DATE_RANGE_CLICKED, payload);
};

export const setReportingConfig = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.SET_REPORTING_CONFIG, payload);
};

export const fetchReportingConfig = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.FETCH_REPORTING_CONFIG, payload);
};

export const setIsOnRequestReport = (payload: any): Action<any> => {
  return updateAction(
    REPORTING_AND_ANALYTICS.SHOW_REQUEST_REPORT_MODAL,
    payload,
  );
};

export const setReportingDateRange = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.REPORTING_DATE_RANGE, payload);
};

export const setReportingDateRangeApplied = (payload: any): Action<any> => {
  return updateAction(
    REPORTING_AND_ANALYTICS.REPORTING_DATE_RANGE_APPLIED,
    payload,
  );
};

export const exportReportData = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.EXPORT_REPORT_DATA, payload);
};

export const fetchTatData = (payload: any): Action<any> => {
  return updateAction(REPORTING_AND_ANALYTICS.FETCH_TAT_DATA, payload);
};

export const setResetBtnClicked = (): Action<void> => {
  return updateAction(REPORTING_AND_ANALYTICS.RESET_BTN_CLICKED);
};

export const clearReportingState = (): Action<void> => ({ type: REPORTING_AND_ANALYTICS.CLEAR_STATE });
